import * as yup from "yup";

export const cherrypointSchema = yup.object().shape({
  comments: yup.string().label("Add comments").required(),
});

export default {
  cherrypointSchema,
};
